import SubNavView from './SubNav'
import SubNavContainer from './SubNavContainer'

export default SubNavContainer(SubNavView)
